<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section class="detail-health-score">
      <page-header :headerName="'Detalhe Health Score'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingScore"/>

            <!-- Filters -->
            <div v-if="!loadingScore" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-4 col-md-4">
                <div class="col-xs-12 col-sm-12 col-md-12 default-box">
                  <h4 class="title-box">
                    <span class="company-name">{{ dataCompanyDetails.companyName }}</span>
                    <span class="days-created">{{ dataCompanyDetails.daysCreated }} Dias</span>
                  </h4>

                  <div class="info-text-2">
                    <p>ID: <span>{{ dataCompanyDetails.companyId }}</span></p>
                  </div>

                  <div class="info-text-2">
                    <p>Plano: <span>{{ dataCompanyDetails.plan }}</span></p>
                  </div>
                  <div class="combo-info-text">
                    <small>Total de usuários: </small>
                    <p>Admin: <span>{{ dataCompanyDetails.totalAdmins }}</span></p>
                    <p>Gestor: <span>{{ dataCompanyDetails.totalManagers }}</span></p>
                    <p>Funcionários: <span>{{ dataCompanyDetails.totalEmployee }}</span></p>
                  </div>
                  <div class="combo-info-text">
                    <small>Total de ajustes: </small>
                    <p>Solicitado: <span>{{ dataCompanyDetails.totalAdjustmentSolicited }}</span></p>
                    <p>Aprovado: <span>{{ dataCompanyDetails.totalAdjustmentApproved }}</span></p>
                    <p>Rejeitado: <span>{{ dataCompanyDetails.totalAdjustmentRejected }}</span></p>
                  </div>
                  <div class="info-text-2">
                    <p>Total de espelho criado: <span>{{ dataCompanyDetails.totalMirrorCreated }}</span></p>
                  </div>
                  <div class="info-text-2">
                    <p>Total de cercos: <span>{{ dataCompanyDetails.totalRegistrationAreaCreated }}</span></p>
                  </div>
                  <div v-if="dataCompanyDetails.isEmailConfirmed !== ''" class="info-text-2">
                    <p>Email Confirmado?: <span>{{ dataCompanyDetails.isEmailConfirmed }}</span></p>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-4 col-md-4">
                <div class="col-xs-12 col-sm-12 col-md-12 default-box">
                  <h4 class="title-box">Datas de acessos</h4>
                  <div class="info-text-2">
                    <p>Último acesso do admin:
                      <span v-if="dataLastActions.lastLoginAdmin">{{ dataLastActions.lastLoginAdmin | formatFullDate }}
                      <span
                        v-bind:class="{'orange': dataLastActions.lastLoginAdminCount >= 10, 'red': dataLastActions.lastLoginAdminCount >= 30}">({{
                          dataLastActions.lastLoginAdminCount
                        }} dias)</span>
                    </span>
                    </p>
                  </div>
                  <div v-if="dataLastActions.isEmailConfirmed !== ''" class="info-text-2">
                    <p>Email Confirmado?: <span>{{ dataLastActions.isEmailConfirmed }}</span></p>
                  </div>
                  <div class="info-text-2">
                    <p>Último acesso do usuário:
                      <span v-if="dataLastActions.lastLoginUser">{{ dataLastActions.lastLoginUser | formatFullDate }}
                      <span
                        v-bind:class="{'orange': dataLastActions.lastLoginUserCount >= 10, 'red': dataLastActions.lastLoginUserCount >= 30}">({{
                          dataLastActions.lastLoginUserCount
                        }} dias)</span>
                    </span>
                    </p>
                  </div>
                  <div class="info-text-2">
                    <p>Último funcionário criado:
                      <span
                        v-if="dataLastActions.lastEmployeeCreated">{{
                          dataLastActions.lastEmployeeCreated | formatFullDate
                        }}
                      <span
                        v-bind:class="{'orange': dataLastActions.lastEmployeeCreatedCount >= 10, 'red': dataLastActions.lastEmployeeCreatedCount >= 30}">({{
                          dataLastActions.lastEmployeeCreatedCount
                        }} dias)</span>
                    </span>
                    </p>
                  </div>
                  <div class="info-text-2">
                    <p>Último ajuste realizado:
                      <span
                        v-if="dataLastActions.lastAdjustmentUpdated">{{
                          dataLastActions.lastAdjustmentUpdated | formatFullDate
                        }}
                      <span
                        v-bind:class="{'orange': dataLastActions.lastAdjustmentUpdatedCount >= 10, 'red': dataLastActions.lastAdjustmentUpdatedCount >= 30}">({{
                          dataLastActions.lastAdjustmentUpdatedCount
                        }} dias)</span>
                    </span>
                    </p>
                  </div>
                  <div class="info-text-2">
                    <p>Última turno criado:
                      <span
                        v-if="dataLastActions.lastWorkshiftCreated">{{
                          dataLastActions.lastWorkshiftCreated | formatFullDate
                        }}
                      <span
                        v-bind:class="{'orange': dataLastActions.lastWorkshiftCreatedCount >= 10, 'red': dataLastActions.lastWorkshiftCreatedCount >= 30}">({{
                          dataLastActions.lastWorkshiftCreatedCount
                        }} dias)</span>
                    </span>
                    </p>
                  </div>
                  <div class="info-text-2">
                    <p>Última equipe criada:
                      <span
                        v-if="dataLastActions.lastTeamCreated">{{ dataLastActions.lastTeamCreated | formatFullDate }}
                      <span
                        v-bind:class="{'orange': dataLastActions.lastTeamCreatedCount >= 10, 'red': dataLastActions.lastTeamCreatedCount >= 30}">({{
                          dataLastActions.lastTeamCreatedCount
                        }} dias)</span>
                    </span>
                    </p>
                  </div>
                  <div class="info-text-2">
                    <p>Último espelho ponto criado:
                      <span
                        v-if="dataLastActions.lastMirrorCreated">{{
                          dataLastActions.lastMirrorCreated | formatFullDate
                        }}
                      <span
                        v-bind:class="{'orange': dataLastActions.lastMirrorCreatedCount >= 10, 'red': dataLastActions.lastMirrorCreatedCount >= 30}">({{
                          dataLastActions.lastMirrorCreatedCount
                        }} dias)</span>
                    </span>
                    </p>
                  </div>
                  <div class="info-text-2">
                    <p>Última unidade de negócio:
                      <span
                        v-if="dataLastActions.lastBusinessUnitCreated">{{
                          dataLastActions.lastBusinessUnitCreated | formatFullDate
                        }}
                      <span
                        v-bind:class="{'orange': dataLastActions.lastBusinessUnitCreatedCount >= 10, 'red': dataLastActions.lastBusinessUnitCreatedCount >= 30}">({{
                          dataLastActions.lastBusinessUnitCreatedCount
                        }} dias)</span>
                    </span>
                    </p>
                  </div>

                </div>
              </div>
              <div class="col-xs-12 col-sm-4 col-md-4">
                <div class="col-xs-12 col-sm-12 col-md-12 default-box">
                  <h4 class="title-box">Notas</h4>

                  <div v-if="dataHealth.score >= 0" class="box-score"
                       v-bind:class="{'warning-score': dataHealth.score >= 4 && dataHealth.score <= 7, 'success-score': dataHealth.score >= 8}">
                    <p>{{ dataHealth.score }}</p>
                  </div>

                  <div class="info-text-2">
                    <p>Fez Onbording?
                      <span>
                      <span v-if="dataHealth.onBoardingDone">Sim</span>
                      <span v-else>Não</span>
                    </span>
                    </p>
                  </div>
                  <div class="info-text-2">
                    <p>Nota para o Admin: <span>{{ dataHealth.adminRating }}</span></p>
                  </div>
                  <div class="info-text-2">
                    <p>NPS Respondido: <span>{{ dataHealth.npsAnswered }}</span></p>
                  </div>
                  <div class="info-text-2">
                    <p>NPS Média: <span>{{ dataHealth.npsAverange }}</span></p>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="!loadingScore" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-4 col-md-4">
                <div class="col-xs-12 col-sm-12 col-md-12 default-box">
                  <h4 class="title-box">Mês atual <span>{{ card1.month }}</span></h4>
                  <div class="info-text-2">
                    <p>Total de Pontos: <span>{{ card1.totalPoints }}</span></p>
                    <p>Total de Faltas: <span>{{ card1.totalFaults }}</span></p>
                    <p>Total de Ocorrências: <span>{{ card1.totalOcurrences }}</span></p>
                    <p>Total do Sentimento: <span>{{ card1.totalFeelingDay }}</span></p>
                    <p>Horas Faltantes: <span>{{ card1.totalMissing }}</span></p>
                    <p>Horas Excedentes: <span>{{ card1.totalPlus }}</span></p>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-4 col-md-4">
                <div class="col-xs-12 col-sm-12 col-md-12 default-box">
                  <h4 class="title-box">MÊS: <span>{{ card2.month }}</span></h4>
                  <div class="info-text-2">
                    <p>Total de Pontos: <span>{{ card2.totalPoints }}</span></p>
                    <p>Total de Faltas: <span>{{ card2.totalFaults }}</span></p>
                    <p>Total de Ocorrências: <span>{{ card2.totalOcurrences }}</span></p>
                    <p>Total do Sentimento: <span>{{ card2.totalFeelingDay }}</span></p>
                    <p>Horas Faltantes: <span>{{ card2.totalMissing }}</span></p>
                    <p>Horas Excedentes: <span>{{ card2.totalPlus }}</span></p>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-4 col-md-4">
                <div class="col-xs-12 col-sm-12 col-md-12 default-box">
                  <h4 class="title-box">MÊS: <span>{{ card3.month }}</span></h4>
                  <div class="info-text-2">
                    <p>Total de Pontos: <span>{{ card3.totalPoints }}</span></p>
                    <p>Total de Faltas: <span>{{ card3.totalFaults }}</span></p>
                    <p>Total de Ocorrências: <span>{{ card3.totalOcurrences }}</span></p>
                    <p>Total do Sentimento: <span>{{ card3.totalFeelingDay }}</span></p>
                    <p>Horas Faltantes: <span>{{ card3.totalMissing }}</span></p>
                    <p>Horas Excedentes: <span>{{ card3.totalPlus }}</span></p>
                  </div>
                </div>
              </div>
            </div>

            <!--            <div v-if="!loadingScore" class="col-xs-12 col-sm-12 col-md-12">-->
            <!--              <div class="col-xs-12 col-sm-4 col-md-12">-->
            <!--                <div class="col-xs-12 col-sm-12 col-md-12 default-box">-->
            <!--                  {{dateTeste}}-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import swal from 'sweetalert';

import {
  GET_HEALTH_SCORE_COMPANY,
  GET_COMPANY_DAILY_METRICS
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import moment from 'moment';

export default {
  name: "detail-health-score",
  components: {
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      failRequest: false,
      loadingScore: false,
      loadingMetrics: false,
      dataCompanyDetails: {},
      dataHealth: {},
      dataLastActions: {},
      card1: {},
      card2: {},
      card3: {},
      dataSearch: {
        dtInit: new Date(moment().subtract(90, 'days')),
        dtEnd: new Date(moment()),
      },
      dateTeste: null
    }
  },
  methods: {
    getScore() {
      this.loadingScore = true;
      let url = GET_HEALTH_SCORE_COMPANY;
      url += "?companyId=" + this.$route.params.companyId;
      url += "&contextCode=" + this.$route.params.context;

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT GET_HEALTH_SCORE_COMPANY:", response.data);

        if (!response.data) {
          swal({
            title: "Aviso",
            text: "Empresa antiga, não possui health score cadastro até o momento",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          }).then((confirm) => {
            if (confirm) {
              window.close();
            }
          });
        } else {
          this.dataCompanyDetails = response.data.companyDetails;
          this.dataHealth = response.data.health;
          this.dataLastActions = response.data.lastActions;

          this.dataLastActions.lastLoginAdminCount = Math.round(((new Date() - new Date(this.dataLastActions.lastLoginAdmin)) / (1000 * 3600 * 24))).toFixed(0);
          ;
          this.dataLastActions.lastLoginUserCount = Math.round(((new Date() - new Date(this.dataLastActions.lastLoginUser)) / (1000 * 3600 * 24))).toFixed(0);
          ;
          this.dataLastActions.lastEmployeeCreatedCount = Math.round(((new Date() - new Date(this.dataLastActions.lastEmployeeCreated)) / (1000 * 3600 * 24))).toFixed(0);
          ;
          this.dataLastActions.lastAdjustmentUpdatedCount = Math.round(((new Date() - new Date(this.dataLastActions.lastAdjustmentUpdated)) / (1000 * 3600 * 24))).toFixed(0);
          ;
          this.dataLastActions.lastWorkshiftCreatedCount = Math.round(((new Date() - new Date(this.dataLastActions.lastWorkshiftCreated)) / (1000 * 3600 * 24))).toFixed(0);
          ;
          this.dataLastActions.lastTeamCreatedCount = Math.round(((new Date() - new Date(this.dataLastActions.lastTeamCreated)) / (1000 * 3600 * 24))).toFixed(0);
          ;
          this.dataLastActions.lastMirrorCreatedCount = Math.round(((new Date() - new Date(this.dataLastActions.lastMirrorCreated)) / (1000 * 3600 * 24))).toFixed(0);
          ;
          this.dataLastActions.lastBusinessUnitCreatedCount = Math.round(((new Date() - new Date(this.dataLastActions.lastBusinessUnitCreated)) / (1000 * 3600 * 24))).toFixed(0);
          ;
        }

        this.loadingScore = false;
        this.failRequest = false;
      }).catch((reason) => {
        this.loadingScore = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    getMetrics() {
      this.loadingMetrics = true;
      let url = GET_COMPANY_DAILY_METRICS;
      url += "?companyId=" + this.$route.params.companyId;
      url += "&contextCode=" + this.$route.params.context;
      url += "&dtInit=" + moment(this.dataSearch.dtInit).format("YYYY-MM-DD");
      url += "&dtEnd=" + moment(this.dataSearch.dtEnd).format("YYYY-MM-DD");

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT GET_COMPANY_DAILY_METRICS:", response.data);

        this.dateTeste = response.data;
        this.card1 = response.data.card1;
        this.card2 = response.data.card2;
        this.card3 = response.data.card3;
        this.loadingMetrics = false;
        this.failRequest = false;
      }).catch((reason) => {
        this.loadingMetrics = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    }
  },
  beforeMount() {
    this.getMetrics();
    this.getScore();
  }
}
</script>

<style lang="scss">
.detail-health-score {
  .title-box {
    margin: 0 0 30px;
    font-weight: 600;
    font-size: 18px;
    text-align: left;
    text-transform: uppercase;

    .days-created {
      float: right;
      font-weight: 500;
      position: relative;
      top: 1px;
    }
  }

  .box-score {
    position: absolute;
    right: 25px;
    border-radius: 100% !important;
    border: 2px solid red;
    width: 50px;
    text-align: center;
    height: 50px;
    line-height: 29px;
    top: 14px;

    p {
      position: relative;
      top: -10px;
      font-size: 20px;
      font-weight: 500;
      color: red;
    }
  }

  .warning-score {
    border: 2px solid orange;

    p {
      color: orange;
    }
  }

  .success-score {
    border: 2px solid green;

    p {
      color: green;
    }
  }

  .combo-info-text {
    margin: 0 0 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #E6E9EC;

    small {
      display: block;
      margin-bottom: 10px;
    }

    p {
      margin: 0 0 5px;
      display: block;
      min-width: 32%;

      span {
        font-weight: 600;
        float: right;
      }
    }
  }

  .company-name {
    color: #054F91;
    font-weight: 600;
    line-height: 22px;
  }

  .m-0 {
    margin-bottom: 0 !important;
  }

  .info-text-2 {
    p {
      margin: 0 0 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #E6E9EC;

      span {
        font-weight: 600;
        float: right;
        font-size: 13px;

        span {
          display: inline-block;
          margin-left: 4px;
          font-size: 12px;
        }
      }

    }

    .orange {
      color: orange !important;
    }

    .red {
      color: red !important;
    }
  }

  .info-text {
    p {
      margin: 0 0 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #E6E9EC;

      span {
        font-weight: 600;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/healtScore/detailHealthScore.vue